import ListBlock from "../F7/ListBlock";
import ListBlockFormItem from "../F7/ListBlockFormItem";
import FieldHandler, { Field } from "./FieldHandler";
import { FC } from "react";

const Fields: FC<{
  fields: Record<string, Omit<Field, "key">>;
  onChange: (field: string, value: Field["value"]) => void;
  onBlur?: () => void;
  title?: string;
}> = ({ fields, onChange, onBlur, title }) => {
  // Get the selected "Field Type" from the fields object
  const selectedFieldType = fields["type"]?.value;

  // Check if the "Options" field should be visible based on the selected "Field Type"
  const renderOptionsField = selectedFieldType === "dropdown" || selectedFieldType === "combobox";
  return (
    <ListBlock title={title}>
      {Object.entries(fields).map(([key, field]) => {
        // Conditionally render the "Options" field based on the "Field Type"
        if (key === "options" && !renderOptionsField) {
          return null;
        }

        return (
          <ListBlockFormItem key={"Fields_ListBlockFormItem_" + key} field={{ ...field, key } as any} label={field.label!}>
            <FieldHandler key={"Fields_FieldHandler_" + key} field={{ ...field, key } as any} onChange={onChange} onBlur={onBlur} />
          </ListBlockFormItem>
        );
      })}
    </ListBlock>
  );
};

export default Fields;
